import { render } from "./SwitchOn.vue?vue&type=template&id=eedbab9a"
import script from "./SwitchOn.vue?vue&type=script&lang=js"
export * from "./SwitchOn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__